
















import { computed, defineComponent, nextTick, onMounted, PropType, ref } from "@vue/composition-api";
import { TagInfo } from "@scrile/api-provider/dist/api/TagsProvider";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "ContentFeedHashtags",
  components: { BaseButton },
  props: {
    tags: { type: Array as PropType<TagInfo[]>, required: true },
    interact: { type: Boolean, default: true },
  },
  setup(props) {
    const container = ref<HTMLElement>();
    const visibleTags = ref<TagInfo[]>([]);
    const expanded = ref(false);

    const hasTagsCount = computed(() => props.tags.length !== visibleTags.value.length);

    const calculateVisibleTags = async () => {
      if (expanded.value) {
        visibleTags.value = props.tags;
        return;
      }
      if (!container.value) return;

      const maxRows = 2;
      const tagHeight = 17;
      const maxHeight = maxRows * tagHeight;

      visibleTags.value = [];
      for (const tag of props.tags) {
        if (container.value.scrollHeight > maxHeight && visibleTags.value.length) {
          visibleTags.value.pop();
          break;
        }
        visibleTags.value.push(tag);
        await nextTick();
      }
    };

    const onShowToggle = () => {
      expanded.value = !expanded.value;
      calculateVisibleTags();
    };

    onMounted(calculateVisibleTags);

    return {
      container,
      visibleTags,
      expanded,
      hasTagsCount,
      onShowToggle,
    };
  },
});
